export default {
  "TeamTable": "_TeamTable_ss3yd_2",
  "RoleChip": "_RoleChip_ss3yd_8"
};import "ni:sha-256;nWZHTtBCsWx4IcI_QEryS2oatncGysC9aAOP3uSaLKg";